import { ReactNode, useRef } from 'react'
import { styled } from '@mui/material/styles'
import { useConditionalHook } from '@weblite/use-conditional-hook'
import {
  Typography,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
} from '@mui/material'
import { nothing } from '$func/utils'
import { OnboardingType } from '$logic/onboarding/types'
import { useOnboarding } from '$logic/onboarding/react-hooks'
import { HotSpot } from '$common/tour/components/hot-spot'

export const ACTION_BUTTON_HEIGHT = 50
export const ACTION_BUTTON_MARGIN_BOTTOM = 10

export const ACTION_BUTTON_CONSUMED_HEIGHT =
  ACTION_BUTTON_HEIGHT + ACTION_BUTTON_MARGIN_BOTTOM

const StyledListItem = styled(ListItem)`
  background-color: white;

  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.05);
`

const StyledListItemButton = styled(ListItemButton)`
  min-height: 50px;

  box-sizing: border-box;
  padding: 0 20px 0 20px;
`

const StyledListItemIcon = styled(ListItemIcon)`
  min-width: unset;
  margin-left: 10px;
`

interface Props {
  text?: string
  icon: ReactNode
  onClick: () => any
  isLast?: boolean
  onboardingType?: OnboardingType
}

export function ActionButton({
  text,
  icon,
  onClick = nothing,
  isLast = true,
  onboardingType,
}: Props) {
  const ref = useRef<HTMLLIElement>(null)
  const { completeOnboarding, enabled: onboardingEnabled } =
    useConditionalHook(!!onboardingType, {
      hook: useOnboarding,
      hookArgs: onboardingType!,
    }) || {}

  return (
    <>
      <StyledListItem
        disablePadding
        sx={{ mb: 0, boxShadow: 'none' }}
        ref={ref}
      >
        <StyledListItemButton
          onClick={() => {
            onClick()
            completeOnboarding?.()
          }}
        >
          <StyledListItemIcon>{icon}</StyledListItemIcon>
          <ListItemText
            primary={
              <Typography
                variant="body2"
                color="secondary500"
                sx={{ display: 'flex', alignItems: 'center' }}
              >
                {text}
                {onboardingEnabled && (
                  <HotSpot sx={{ mr: '18px' }} containerRef={ref} />
                )}
              </Typography>
            }
          />
        </StyledListItemButton>
      </StyledListItem>
      {!isLast && <Divider sx={{ marginRight: '54px' }} />}
    </>
  )
}
